import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface SplitLayoutProps {
  main: ReactNode;
  sidebar: ReactNode;
  mainWidth?: number; // percentage (e.g., 75 for 75%)
  gap?: number; // theme spacing units
}

const SplitLayout = ({ main, sidebar, mainWidth = 75, gap = 3 }: SplitLayoutProps) => {
  const sidebarWidth = 100 - mainWidth;

  return (
    <Box sx={{ display: 'flex', gap, width: '100%' }}>
      <Box sx={{ flex: `0 0 ${mainWidth}%`, minWidth: 0 }}>
        {main}
      </Box>
      <Box sx={{ flex: `0 0 ${sidebarWidth}%`, minWidth: 0 }}>
        {sidebar}
      </Box>
    </Box>
  );
};

export default SplitLayout;
